
document.addEventListener('DOMContentLoaded', function() {
    // Get DOM elements with null checks
    const video = document.getElementById('mercato-video');
    const playButton = document.getElementById('play-button');
    const volumeControls = document.getElementById('volume-controls');
    const muteButton = document.getElementById('mute-button');
    const volumeSlider = document.getElementById('volume-slider');
    const volumeIcon = document.getElementById('volume-icon');

    // Check if essential elements exist
    if (!video || !playButton) {
        return;
    }

    let hideControlsTimeout;

    // Function declarations
    function showVolumeControls() {
        if (volumeControls) {
            volumeControls.classList.add('show');
            resetHideTimer();
        }
    }

    function hideVolumeControls() {
        if (volumeControls) {
            volumeControls.classList.remove('show');
        }
    }

    function resetHideTimer() {
        clearTimeout(hideControlsTimeout);
        hideControlsTimeout = setTimeout(() => {
            if (!video.paused) {
                hideVolumeControls();
            }
        }, 3000);
    }

    function updateVolumeIcon() {
        if (!volumeIcon) return;

        if (video.muted || video.volume === 0) {
            volumeIcon.innerHTML = '<path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>';
        } else if (video.volume < 0.5) {
            volumeIcon.innerHTML = '<path d="M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"/>';
        } else {
            volumeIcon.innerHTML = '<path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>';
        }
    }

    function updatePlayButtonIcon() {
        if (!playButton) return;

        const svg = playButton.querySelector('svg');
        if (video.paused) {
            // Show play icon
            svg.innerHTML = '<path d="M8 5v14l11-7z"/>';
        } else {
            // Show pause icon
            svg.innerHTML = '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>';
        }
    }

    // Toggle play/pause function
    function togglePlayPause() {
        if (video.paused) {
            video.play().then(() => {
                playButton.style.display = 'none';
                showVolumeControls();
                updatePlayButtonIcon();
            }).catch(error => {
                console.error('Error playing video:', error);
            });
        } else {
            video.pause();
            updatePlayButtonIcon();
        }
    }

    // Play/Pause functionality
    playButton.addEventListener('click', togglePlayPause);

    // Add click event to video for play/pause toggle
    video.addEventListener('click', togglePlayPause);

    video.addEventListener('pause', function() {
        playButton.style.display = 'flex';
        hideVolumeControls();
        updatePlayButtonIcon();
    });

    video.addEventListener('ended', function() {
        playButton.style.display = 'flex';
        hideVolumeControls();
        updatePlayButtonIcon();
    });

    video.addEventListener('playing', function() {
        playButton.style.display = 'none';
        showVolumeControls();
        updatePlayButtonIcon();
    });

    // Volume controls functionality (only if elements exist)
    if (muteButton && volumeSlider) {
        muteButton.addEventListener('click', function() {
            if (video.muted) {
                video.muted = false;
                volumeSlider.value = video.volume;
                updateVolumeIcon();
            } else {
                video.muted = true;
                updateVolumeIcon();
            }
        });

        volumeSlider.addEventListener('input', function() {
            video.volume = this.value;
            video.muted = false;
            updateVolumeIcon();
        });
    }

    // Show controls on mouse movement
    video.addEventListener('mousemove', function() {
        if (!video.paused) {
            showVolumeControls();
        }
    });

    // Keep controls visible when hovering over them
    if (volumeControls) {
        volumeControls.addEventListener('mouseenter', function() {
            clearTimeout(hideControlsTimeout);
        });

        volumeControls.addEventListener('mouseleave', function() {
            resetHideTimer();
        });
    }

    // Keyboard support for spacebar play/pause
    document.addEventListener('keydown', function(event) {
        // Only trigger if the video player area is in focus or no input is focused
        if (event.code === 'Space' && !document.querySelector('input:focus, textarea:focus')) {
            event.preventDefault();
            togglePlayPause();
        }
    });

    // Initialize volume icon and play button icon
    updateVolumeIcon();
    updatePlayButtonIcon();
});
